<div class="station-selection-menu">
  <sc-padding fitHeight>
    <sc-flex vertical stretchContent fitHeight>
      <sc-flex>
        <sc-title><sc-dictionary-label dictionaryKey="Stationsauswahl"
        defaultValue="Stationsauswahl"></sc-dictionary-label></sc-title>
        <sc-content-spacer grow></sc-content-spacer>
        <sc-icon iconClass="fa-close close-action" (click)="clickClose()"></sc-icon>
      </sc-flex>
      <sc-content-spacer vertical></sc-content-spacer>
      <sc-flex-fitting-content vertical>
        <sc-scroll-pane>
          @for (group of stationGroups; track group; let i = $index) {
            @if (i > 0) {
              <sc-content-spacer vertical></sc-content-spacer>
            }
            <div class="group-container">
              {{group.name}}
              @for (set of group.stationSets; track set) {
                <sc-content-spacer vertical></sc-content-spacer>
                <div class="station-set-container">
                  {{set.name}}
                  @for (station of set.stations; track station; let k = $index) {
                    <sc-content-spacer vertical></sc-content-spacer>
                    <div class="station" (click)="selectStation(set, station)">{{station.name}}</div>
                  }
                </div>
              }
            </div>
          }
        </sc-scroll-pane>
      </sc-flex-fitting-content>
    </sc-flex>
  </sc-padding>
</div>
